/** Shown when the user is signed in but the token lacks the usage:read
 *  permission (client-side `canRead` gate). Names the role an admin must grant
 *  in Guardius and offers a way back out. Enforcement is server-side — the query
 *  Lambda's Guardius authorizer 403s an unauthorized read regardless of this
 *  screen; this only avoids rendering a shell the user can't populate. */

import { useAuth } from '../lib/auth';

export default function NoAccess() {
  const { signOut } = useAuth();
  return (
    <div className="login">
      <div className="card">
        <h1>No access</h1>
        <p className="note">
          Your account is signed in but not authorized to read Watchtower usage.
          Ask an administrator to grant you the{' '}
          <code>penseur-watchtower-usage-reader</code> role in Guardius, then sign
          in again.
        </p>
        <button type="button" className="btn app-signout" onClick={signOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
